import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { shouldSilenceError } from './app/global-error-handler';
import { environment } from './environments/environment';
import { Location } from '@angular/common';

declare const newrelic: { setErrorHandler?: (cb: (err: unknown) => boolean) => void } | undefined;

if (environment.production || environment.qa) {
  enableProdMode();
}

// Apply the same silenced patterns to NR's auto-capture (window.onerror,
// unhandled rejections). The Angular handler doesn't see these — they bypass
// the zone entirely. Returning true tells the NR agent to drop the error.
if (typeof newrelic !== 'undefined' && newrelic?.setErrorHandler) {
  newrelic.setErrorHandler((err) => !!shouldSilenceError(err));
}

// Prevent stripping of trailing slash
Location.stripTrailingSlash = function stripTrailingSlashNew(url: string): string {
  return url;
};

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});
